// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CounterBadge-base__CZC1X{display:flex;gap:var(--size-0_25);align-items:center;-webkit-user-select:none;-moz-user-select:none;user-select:none}.CounterBadge-current__JZsvI{color:var(--gray-12);font:var(--font-caption-medium-500);font-feature-settings:var(--feature-settings-caption-medium-500);letter-spacing:var(--letter-spacing-caption-medium-500)}.CounterBadge-total__Eyb94{color:var(--gray-a10);font:var(--font-caption-medium-400);font-feature-settings:var(--feature-settings-caption-medium-400);letter-spacing:var(--letter-spacing-caption-medium-400)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "CounterBadge-base__CZC1X",
	"current": "CounterBadge-current__JZsvI",
	"total": "CounterBadge-total__Eyb94"
};
export default ___CSS_LOADER_EXPORT___;
